<template>
  <div>
       <div class="text-center" v-if="Loading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

    <div class="panal mt-20" v-else-if="!Loading && selectEvent.length >0">
      <div class="panal-header"> {{selectEvent[0].NameEN ? selectEvent[0].NameEN : ''}}  </div>
      <div class="panal-body">
        <h5>Event Description</h5>
        <p>Address: {{selectEvent[0].GovernorateNameEN}}, {{selectEvent[0].Address}} </p>
       <p>Date: From {{selectEvent[0].StartDate | moment('ll')}} To {{selectEvent[0].EndDate | moment('ll')}} </p> 

        <div class="divider"></div>
        <b-form  @submit.prevent="onSubmit" v-if="show" method="post">
        <div class="row">
        <div  class="col-12 col-md-6 mb-1">
          

<b-form-group id="input-group-1" label="Your Name:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.Name"
          placeholder="Enter name"
          required 
          class="form-control su-border"
          name="Name"
          v-validate="'required|excluded:0'"
        ></b-form-input>
         <div v-if="errors.has('Name')" class="alert-danger">{{errors.first('Name')}}</div>
 </b-form-group>


        </div>
        <div  class="col-12 col-md-6 mb-1">
<b-form-group id="input-group-2" label="Your Phone:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.PhoneNumber"
          placeholder="Enter phone"
          type="number"
          name="PhoneNumber"
          required 
          class=" su-border form-control"
           v-validate="'required|excluded:0'"
        ></b-form-input>
         <div v-if="errors.has('PhoneNumber')" class="alert-danger">{{errors.first('PhoneNumber')}}</div>

      </b-form-group>
        </div>
         <div  class="col-12 col-md-6 mb-1">
      
      
        <b-form-group
        id="input-group-4"
        label="Email address:"
        label-for="input-4"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="input-4"
          v-model="form.Email"
          name="Email"
          type="email"
          placeholder="Enter email"
          required 
          class="form-control su-border"
           v-validate="'required|excluded:0'"
           
        ></b-form-input>
         <div v-if="errors.has('Email')" class="alert-danger">{{errors.first('Email')}}</div>

      </b-form-group>
      
      
      
      </div>
           <div  class="col-12 col-md-6 mb-1">
     <b-form-group id="input-group-3" label="NationalID:" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="form.NationalID"
          name="NationalID"
          placeholder="Enter NationalID"
          type="number"
          @blur="handleBlur"
          required 
          class="form-control su-border"
           v-validate="'required|excluded:0'"
        ></b-form-input>
         <div v-if="errors.has('NationalID')" class="alert-danger">{{errors.first('NationalID')}}</div>

      </b-form-group>
        
        </div>

           <div  class="col-12 col-md-6 mb-1">

       
       

        <b-form-group id="input-group-5" label="BirthDate:" label-for="input-5">
        <b-form-input
          id="input-5"
          v-model="form.BirthDate"
          name="BirthDate"
          placeholder="Enter BirthDate"
          type="date"
          required 
          class="form-control su-border"
           v-validate="'required|excluded:0'"
        ></b-form-input>
         <div v-if="errors.has('BirthDate')" class="alert-danger">{{errors.first('BirthDate')}}</div>

      </b-form-group>
        
        </div>


          <div  class="col-12 col-md-6 mb-1">
  
         <b-form-group id="input-group-6" label="Current School:" label-for="input-6">
        <b-form-input
          id="input-6"
          v-model="form.CurrentSchool"
          name="CurrentSchool"
          placeholder="Enter Current School"
          required 
          class="form-control su-border"
           v-validate="'required|excluded:0'"
        ></b-form-input>
         <div v-if="errors.has('CurrentSchool')" class="alert-danger">{{errors.first('CurrentSchool')}}</div>

 </b-form-group>
        
        </div>


      <div  class="col-12 col-md-6 mb-1">

<b-form-group id="input-group-7" label="High school certiﬁcate Group:" label-for="input-7" >
       



   <b-form-select id="input-13" name="certiﬁcateGroup"  
        v-model="form.certiﬁcateGroup" 
        @change="certiﬁcateGroupFunction()"
        v-validate="'required|excluded:0'">
                  
           <option v-for="g in certiﬁcateGroup" :key="g.Serial" :value="g.Serial">
         {{g.GroupNameEN}}
       </option>
           
       </b-form-select>
        <div v-if="errors.has('certiﬁcateGroup')" class="alert-danger">{{errors.first('certiﬁcateGroup')}}</div>
 </b-form-group>
        
        </div>

        <div  class="col-12 col-md-6 mb-1">
    
         <b-form-group id="input-group-8" label="High school certiﬁcate :" label-for="input-8">
        <b-form-select
          id="input-8"
          v-model="form.HighSchoolCertificateID"
          name="HighSchoolCertificateID"
         required 
          v-validate="'required|excluded:0'"
        >
        
        <option v-for="c in HighSchoolCertificateID" :key="c.GroupID" :value="c.serial">
         {{c.CertificationNameEN}}
       </option>
        
        
        </b-form-select>
        <div v-if="errors.has('HighSchoolCertificateID')" class="alert-danger">{{errors.first('HighSchoolCertificateID')}}</div>
      </b-form-group>
        

      </div>

        <div  class="col-12 col-md-6 mb-1">
  
         <b-form-group id="input-group-9" label="Address:" label-for="input-9">
        <b-form-input
          id="input-9"
          v-model="form.Addresss"
          name="Addresss"
          placeholder="Enter the addresss"
          required 
          class="form-control su-border"
           v-validate="'required|excluded:0'"
        ></b-form-input>
        <div v-if="errors.has('Addresss')" class="alert-danger">{{errors.first('Addresss')}}</div>
        
 </b-form-group>
        
        </div>

        <div id="v-model-checkbox" class="col-12 col-md-6 mt-4">
            <b-form-checkbox type="checkbox"  id="InterestedFlag" class="font-weight-bold form-check-input" name="InterestedFlag" 
                              v-model="form.InterestedFlag" > 
                               <label class="form-check-label" for="InterestedFlag"> Interested </label>                               
            </b-form-checkbox> 
           
       </div>
           

<div class="w-100">
  <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
</div>


  

  <div class="container-fluid mt-5 ">
  <div class="row">
    <div class="col-sm">
      
    </div>
    <div class="col-sm-4">
     <button class="btn btn-success text-right float-right mr-5" type="submit" @click="onSubmit" :disabled= !isdisabled> Save </button>
    </div>
    <div class="col-sm-5">
     <div class="text-right float-right mr-0"> 
  <!-- --> 
  <!-- :disabled = isdisabled -->
  <button class="nav-link btn btn-outline-secondary  text-right float-right "  :disabled = isdisabled
          id="v-pills-History-tab3" data-toggle="pill" href="#v-pills-History3" 
          role="tab" aria-controls="v-pills-History3"  > Next
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
</svg>
  </button>
</div>
    </div>
  </div>
</div>


        </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>


import EventService from '../../services/Event/event.services'

export default {
  name: "ActiveEvent",
  data() {
    return {
       Loading: true,
       empty: false,
       isdisabled : true,  
form: {         
          Name: '',
                    SystemMethodID: '',
          PhoneNumber: '',
          Email: '',
          NationalID: '',
          BirthDate:'',
          CurrentSchool:'',
          serial: '',
          EventID:'',  
          Addresss:'', 
          HighSchoolCertificateID: [], 
          SearchSelectBasicData:[],
          certiﬁcateGroup:[], 
           selectEvent: [],
           UserID: '',
          InterestedFlag: ''
        },
      certiﬁcateGroup:[], 
       HighSchoolCertificateID: [],
       SearchSelectBasicData:[],
       selectEvent: [],
        show: true,
        message : ''

    };
  },
   computed:{
          currentUser(){
      return this.$store.state.auth.user.LoginInfo[0].UserID;
    },
        
        },

   mounted(){
       EventService.SelectMarketingEvent(this.$route.params.Serial).then(Response =>{
               this.Loading = false ;
               this.selectEvent = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               //console.log('Desciption Event => ',this.selectEvent)
           }, error => {
              this.empty = true;
              this.Loading = false ;
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 


EventService.SelectAllCertificationGroups().then(Response =>{
               
               this.certiﬁcateGroup = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
           }, error => {
              this.empty = true;
           
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
 
 },

   methods: {

certiﬁcateGroupFunction:function() {
      //this.highSchoolCertificate =  event.target.value;
            EventService.Admission_SelectAllCertificationTypeByGroup(this.form.certiﬁcateGroup).then(Response =>{
             
               this.HighSchoolCertificateID= Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
           }, error => {
             this.empty = true;
            
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

    },





      onSubmit(event) {

        //  alert(JSON.stringify(this.form))
         this.$validator.validate().then(valid => {
           if(valid)
           {
            // alert(valid) 34
EventService.BasicData_Insert(this.form.Name,1 ,this.form.NationalID, this.$route.params.Serial, this.currentUser , this.form.PhoneNumber, 
                                      this.form.Email, this.form.Addresss, this.form.BirthDate, this.form.HighSchoolCertificateID, this.form.CurrentSchool, this.form.InterestedFlag).then(Response =>{
          this.message="Request Created successfully " +Response.data
          this.successful =true;
        //  window.location.href="#v-pills-History3"
              // console.log('Response ',Response.data)

        this.isdisabled = false
     

        }, 
        error => {
          //  alert("interested = ", this.InterestedFlag)
          this.empty =false
          this.successful =false;
        
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
           }else{
            // alert(valid)
             event.preventDefault();
           }
         })

 




      
        event.preventDefault();
        //alert(JSON.stringify(this.form))
      },

      async handleBlur(){
            if(this.form.NationalID == ''|| this.form.NationalID == null || this.form.NationalID == undefined )
             {
               return false;              
             }
             else
             {
             this.SearchSelectBasicData = await EventService.SelectBasicData(this.form.Email, this.form.NationalID).then(Response =>{
                                
                  setTimeout(  this.SearchSelectBasicData= Response.data,3000)
                
                  this.empty =false;
                
                    // eslint-disable-next-line no-console
                  console.log('Search Result => ',this.SearchSelectBasicData)
                  
                  //  alert("Done ");
                  //  if(Response.data.length > 0)
                  //  {
                    
                  //  }
                  localStorage.setItem("NationalID", JSON.stringify(this.SearchSelectBasicData));
                  // JSON.parse(JSON.stringify(res.data))
                      this.$router.push('/SearchResult');         
             
            
             
           }, error => {
             this.empty = true;
            
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

             }
       
      }
   }

};
</script>


<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
</style>